import type {PropertyValue} from '@github-ui/custom-properties-types'
import {areEqualValues} from '@github-ui/custom-properties-types/helpers'
import {useCallback, useEffect, useRef} from 'react'

export function useCopilotSuggestionMetrics() {
  const suggestionsRef = useRef<Map<string, PropertyValue>>(new Map())

  useEffect(() => {
    const ref = suggestionsRef.current
    return () => {
      ref.clear()
    }
  }, [])

  const onSuggestion = useCallback((propertyName: string, value?: PropertyValue) => {
    if (value !== undefined) {
      suggestionsRef.current.set(propertyName, value)
    }
  }, [])

  const getMetrics = useCallback((propertyValuesMap: Record<string, {value?: PropertyValue}>) => {
    const suggestions = suggestionsRef.current
    if (suggestions.size === 0) return undefined
    const accepted = Array.from(suggestions).reduce(
      (count, [propertyName, suggestedValue]) =>
        areEqualValues(propertyValuesMap[propertyName]?.value, suggestedValue) ? count + 1 : count,
      0,
    )
    return {copilotSuggestionsAttempted: suggestions.size, copilotSuggestionsAccepted: accepted}
  }, [])

  return {onSuggestion, getMetrics}
}
